import React from 'react'
import Modal from 'react-bootstrap/Modal'

import Processors from "../../../../utils/Processors"


export default class UpdateConnectProcessorModal extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      ...this._getState(props),
      show: props.show,
    }

  }

  componentWillReceiveProps(nextProps){
    this.setState(this._getState(nextProps))
  }

  _getState(props){
    return {
      ...props,
      company: props.company,
      association: props.association,
      connectedProcessor: props.connectedProcessor ? JSON.parse(JSON.stringify(props.connectedProcessor)) : null,
    }
  }

  _renderContent(){
    let {
      show,
      company,
      association,
      connectedProcessor,
    } = this.state

    const ConnectProcessorComponent = Processors.getConnectComponent(connectedProcessor.processor)
    if(ConnectProcessorComponent){
      return (
        <ConnectProcessorComponent
          company={company}
          association={association}
          processor={connectedProcessor.processor}
          data={connectedProcessor.data}
          onCancel={processor => this.props.onHide()}
          onUpdated={() => this.props.onUpdated()}
        />
      )
    }

    return null
  }

  render() {
    let {
      show,
      connectedProcessor,
    } = this.state

    if(!connectedProcessor) return null

    return (
      <Modal
        show={show}
        onHide={() => this.props.onHide()}
        className={""}
        dialogClassName={"modal-dialog modal-dialog-centered modal-lg"}
      >
        <Modal.Header closeButton>
          <Modal.Title>{`Update ${connectedProcessor.processor.name}`}</Modal.Title>
        </Modal.Header>

        { this._renderContent() }

      </Modal>
    )
  }
}
